import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

// ✅ Global 401 handler
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const isAuthRefreshRequest = error.config?.url?.includes("/api/auth/refresh-token");

    if (error.response?.status === 401 && !isAuthRefreshRequest) {
      console.warn("🔐 Token expired or unauthorized — redirecting to login...");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default apiClient;
